import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppConfig } from '../../../../app-config';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
    /* eslint-disable @angular-eslint/no-output-on-prefix */
    @Output() onNavCollapse = new EventEmitter();
    /* eslint-disable @angular-eslint/no-output-on-prefix */
    @Output() onNavCollapsedMob = new EventEmitter();
    public appConfig: any;
    public navCollapsed;
    public navCollapsedMob;
    public windowWidth: number;

    constructor() {
        this.appConfig = AppConfig.config;
        this.windowWidth = window.innerWidth;
        this.navCollapsed = this.windowWidth >= 992 ? this.appConfig['collapseMenu'] : false;
        this.navCollapsedMob = false;
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit(): void {}

    navCollapse(): void {
        if (this.windowWidth >= 992) {
            this.navCollapsed = !this.navCollapsed;
            this.onNavCollapse.emit();
        }
    }

    navCollapseMob(): void {
        if (this.windowWidth < 992) {
            this.onNavCollapsedMob.emit();
        }
    }
}
